import { Fragment } from "react";

// ── Data ──────────────────────────────────────────────────────────────────────
// TODO: replace these with the real store details.
const STORES = [
  {
    region: "Jalandhar",
    company: "TYKA Showroom",
    address: ["112, Sports Market, near Jhandian Wala Peer Chowk, Nijatam Nagar, Basti Nau, Football Chowk, Punjab 144002"],
    phones: ["+91-9888216407"],
    email: "shoptksportsworld@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d852.0613817521215!2d75.55852148554901!3d31.324591716884377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5aed77aaf9eb%3A0xc2c00bf6ca78f6bd!2sTK%20Sports%20Marketing%20Pvt.%20Ltd%20%7C%20TYKA!5e0!3m2!1sen!2sin!4v1787378906516!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/583RDc2ZvviVja5q7",
  },
  {
    region: "Chandigarh",
    company: "Cricketershop.com",
    address: ["SCO 58, In Side Of Cricketershop.com, Basement, Sec. 32c, Chandigarh, 160030"],
    phones: ["+91-9779942095"],
    email: "tykasales.tricity@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3430.402050567168!2d76.77290587934571!3d30.707095799999994!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fedf8615dad47%3A0xd46650fad96aeaee!2sTyka%20Chandigarh!5e0!3m2!1sen!2sin!4v1787379076030!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/ErjTnqy7kQaDfXDPA",
  },
  {
    region: "Delhi",
    company: "Tyka Only Sports",
    address: ["Shop number - 803, Ground floor, South Extension I, Arjun Nagar, Kotla Mubarakpur, New Delhi, Delhi 110003"],
    phones: ["+91-92899490077"],
    email: "onlysportsmultibrand@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56084.865917341485!2d77.1019704!3d28.5305773!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce33a199ab925%3A0x48d97b9684aa337f!2sTyka%20Only%20Sports!5e0!3m2!1sen!2sin!4v1787379330390!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/2Nsv8NvnFZTPvdqC8",
  },
  {
    region: "Gurgaon",
    company: "TYKA | AURM | SHREY | BAS",
    address: ["Plot No. 5, Sector 17/18 Dividing Rd, near IFFCO Chowk, Sukhrali Enclave, Sector 17, Gurugram, Haryana 122015"],
    phones: ["+91-9599155555"],
    email: "sales.ncr@tyka.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56107.88810952996!2d76.9818094!3d28.4872852!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d198529a82cdd%3A0x9aa64eb7f6c777ff!2sTYKA%20%7C%20AURM%20%7C%20SHREY%20%7C%20BAS!5e0!3m2!1sen!2sin!4v1787379711183!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/LkUzThLBpADBzhp28",
  },
  {
    region: "Bengaluru",
    company: "Shaan Sports",
    address: ["42/1, First Floor, Opp. Gold Palace, Parallel to Commercial street, Dispensary Road, Tasker Town, Bengaluru, Karnataka 560001"],
    phones: ["+91-7829912526 | 9591332526 "],
    email: "sales.shaansports@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8451505610287!2d77.60556807585726!3d12.981754214654048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16882be31ef9%3A0xbff318d74c257473!2sShaan%20Sports!5e0!3m2!1sen!2sin!4v1788165832131!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/wu5dvjUV6K7gUrxVA",
  },
];

// ── Icons ─────────────────────────────────────────────────────────────────────

function LocationIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      className="shrink-0 mt-0.5 text-gray-500"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function BagIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="text-gray-400"
    >
      <path d="M20 6h-2.18c.07-.44.18-.88.18-1.36C18 2.51 16.49 1 14.64 1H9.36C7.51 1 6 2.51 6 4.64c0 .48.11.92.18 1.36H4C2.9 6 2 6.9 2 8v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5.82-1.27C14.42 4.37 14.08 4 13.64 4H10.36c-.44 0-.78.37-.54.73l.64 1.27H9.18c-.05-.22-.18-.47-.18-.73C9 3.67 9.67 3 10.36 3h3.28c.69 0 1.36.67 1.36 1.27 0 .26-.13.51-.18.73h-1.28l.64-1.27zM20 19H4V8h16v11z" />
    </svg>
  );
}

// ── Sub-components ────────────────────────────────────────────────────────────

function MapEmbed({ src, height = 240, title = "map" }) {
  return (
    <iframe
      src={src}
      width="100%"
      height={height}
      className="block w-full mt-3 rounded border border-gray-200"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title={title}
    />
  );
}

function LocationCard({ item, isLastInRow, isLastRow }) {
  return (
    <div
      className={[
        "p-5",
        !isLastInRow ? "md:border-r border-gray-200" : "",
        !isLastRow ? "border-b border-gray-200" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {/* Region heading */}
      <h3 className="text-xl font-bold text-black mb-2.5 leading-snug">
        TYKA : {item.region}
      </h3>

      {/* Company name */}
      <div className="flex items-start gap-1.5 text-sm font-bold text-black uppercase tracking-wide mb-1.5">
        <LocationIcon />
        <span>{item.company}</span>
      </div>

      {/* Address lines */}
      {item.address.map((line, i) => (
        <p key={i} className="text-sm leading-relaxed text-black">
          {line}
        </p>
      ))}

      {/* Phones */}
      {item.phones.map((p, i) => (
        <a
          key={i}
          href={`tel:${p.replace(/[^\d+]/g, "")}`}
          className="text-sm leading-relaxed text-black hover:underline block"
        >
          {p}
        </a>
      ))}

      {/* Email */}
      {item.email && (
        <a
          href={`mailto:${item.email}`}
          className="text-sm text-black hover:underline block mt-0.5"
        >
          {item.email}
        </a>
      )}

      {/* Map */}
      <MapEmbed src={item.mapSrc} height={280} title={`${item.company} map`} />
    </div>
  );
}

function RowDivider() {
  return (
    <div className="col-span-full relative flex items-center justify-center h-px">
      <div className="w-full h-px bg-gray-200" />
      <div className="absolute bg-white px-2.5 flex items-center justify-center">
        <BagIcon />
      </div>
    </div>
  );
}

function SectionDivider({ label }) {
  return (
    <div className="flex items-center gap-2.5 my-8 text-black-400 text-[13px] tracking-widest uppercase font-medium">
      <div className="flex-1 h-px bg-gray-200" />
      <span>{label}</span>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  );
}

/** Renders any list of locations in the 3-up bordered grid with bag dividers. */
function LocationGrid({ items }) {
  const rows = [];
  for (let i = 0; i < items.length; i += 3) {
    rows.push(items.slice(i, i + 3));
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 border border-gray-200 rounded-lg overflow-hidden">
      {rows.map((row, rowIdx) => (
        <Fragment key={`row-${rowIdx}`}>
          {row.map((item, colIdx) => (
            <LocationCard
              key={item.region}
              item={item}
              isLastInRow={colIdx === row.length - 1 || colIdx === 2}
              isLastRow={rowIdx === rows.length - 1}
            />
          ))}
          {rowIdx < rows.length - 1 && <RowDivider />}
        </Fragment>
      ))}
    </div>
  );
}

// ── Main Page ─────────────────────────────────────────────────────────────────

export default function OurStores() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-10 pb-20">
      {/* ── Our Stores ── */}
      <SectionDivider label="Our Stores" />
      <LocationGrid items={STORES} />


    </div>
  );
}